import React, { useState, useEffect } from "react";
import RatingGame from "../../components/RatingGameStatistics";
import useGame from "../../hooks/useGame";
import useRatingQuestions from "../../hooks/useRatingQuestions";
import { navigate } from "@reach/router";
import LoadingScreen from "../../components/LoadingScreen";
import PartWholeTemplate from "../../assets/NumberAndPlace/PartWholeTemplate.png";
import { debug } from "util";

function GenerateUniqueRandom(min, max, notthisArray) {
  var returnMe = Math.floor(Math.random() * (max - min) + min);
  console.log(notthisArray)

  if (notthisArray.includes(returnMe)) {
    return GenerateUniqueRandom(min, max, notthisArray);
  }

  return returnMe;
}

function GenerateRandom(min, max) {
  return Math.floor(Math.random() * (max - min) + min);
}


function GetImage(image){
  return '/qimages/' + image+".png";
}



function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}



function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

function uniqueItem(value, list) {
  console.log(list);
  for (var i = 0; i < list.length; i++)
    if (value == list[i])
      return false;
  return true;
}

//Runs basic formula up to 6 times while not unique
//Makes a resonable random number if this fails
function uniqueFormula(input, insert, list) {
  var ans = parseFormula(input, insert);
  if (uniqueItem(ans, list))
    return ans;

    console.log("fnaf")
    console.log(list);
  for (var i = 0; i < 5; i++) {
    ans = parseFormula(input, insert);
    if (uniqueItem(ans, list))
      return ans;
  }

  var max = parseFloat(list[0]);
  if (max < 10)
    max = 10;
  for (var i = 0; i < 5; i++) {
    ans = parseFormula("Rand|" + (0).toString() + "|" + max.toString() + "|1", input, insert);
    if (uniqueItem(ans, list))
      return ans;
  }
  return ans;
}

function parseFormula(input, insert) {
  var newInput = input.replace("$", insert[0]).replace("^", insert[1]);
  console.log(newInput);
  if (input.includes("|")) {
    let parts = newInput.split('|');
    console.log(parts);
    if (parts[0] === "Add")
      return parseInt(parts[1]) + parseInt(parts[2]);

    else if (parts[0] === "Sub")
      return parseInt(parts[1]) - parseInt(parts[2]);

    else if (parts[0] === "Seque4")
      return parseInt(parts[1]) + "; " + (parseInt(parts[1]) + parseInt(parts[2])) + "; " + (parseInt(parts[1]) + parseInt(parts[2] * 2)) + "; " + (parseInt(parts[1]) + parseInt(parts[2] * 3));

    else if (parts[0] === "Rand")
      return Math.round(parseInt(parts[1]) + Math.random() * (parseInt(parts[2]) - parseInt(parts[1]))) * parseInt(parts[3]);

    else if (parts[0] === "Rand2") {
      var answer = Math.round(parseInt(parts[1]) + Math.random() * (parseInt(parts[2]) - parseInt(parts[1])) / 2) * parseInt(parts[3]);
      var answer2 = Math.round(answer + Math.random() * (parseInt(parts[2]) - parseInt(parts[1])) / 2) * parseInt(parts[3]);
      return (answer + "|" + answer2);
    }
    else if (parts[0] === "Char"){

      return parts[1].toString()[parts[1].length - parseInt(parts[2])];
    }
    else if (parts[0] === "Round") {
      var round = parseInt(parts[1]) / parseInt(parts[2]);
      var ans = Math.round(round) * parseInt(parts[2]);
      return ans;
    }


    else if (parts[0] === "RoundUp") {
      var round = parseInt(parts[1]) / parseInt(parts[2]);
      var ans = 0;
      if (Math.ceil(round) * parseInt(parts[2]) == Math.round(round) * parseInt(parts[2])) {
        ans = Math.ceil(round) * parseInt(parts[2]) + parseInt(parts[2]);
      } else {
        ans = Math.ceil(round) * parseInt(parts[2]);
      }
      return ans;
    }


    else if (parts[0] === "RoundDown") {
      var round = parseInt(parts[1]) / parseInt(parts[2]);
      var ans = 0;
      if (Math.floor(round) * parseInt(parts[2]) == Math.round(round) * parseInt(parts[2])) {
        ans = Math.floor(round) * parseInt(parts[2]) - parseInt(parts[2]);
      } else {
        ans = Math.floor(round) * parseInt(parts[2]);
      }
      return ans;
    }

  }
  return newInput;
}

export default function Rating({ ...props }) {
  const game = useGame(props.game.id);
  const { questions } = useRatingQuestions({ game_type: game.game_type }, game);
  const [levels, setLevels] = useState();
  //console.log("Questions");
  //console.log(questions);

  // once the questions have been retrieved we then generate the questionlist for the rating game
  useEffect(() => {
    if (questions !== undefined) {
      let levelQs = [];
      questions.forEach((levelQuestions, i) => {

        var newLevelQuestions = [];
        levelQuestions.forEach(q => {
          //console.log(q);
          /*for (var i = 1; i < 12; i++) {*/
          let generatedCalculation = [];


          let qKeys = ["Num1Q1", "Num1Q2", "Num3Q1", "Num4Q1", "Num5Q1", "Num6Q1", "Num7Q1", "Num7Q111", "Num8Q1", "Num9Q1", "Num9Q2", "Num11Q1", "Num12Q1", "Num13Q1", "Num14Q1", "Num15Q1", "Num15Q38", "Num15Q112", "Num15Q185", "Num16Q1", "Num16Q123", "Num16Q184", "Num17Q1", "Num17Q2", "Num19Q1", "Num20Q1", "Num21Q1", "Num22Q1", "Num23Q1", "Num24Q1", "Num24Q111", "Num25Q1", "Num25Q111", "Num25Q184", "Num25Q292", "Num26Q1", "Num26Q13", "Num26Q19", "Num26Q24", "Num26Q34", "Num26Q44", "Num26Q53", "Num26Q63", "Num26Q73", "Num26Q83", "Num27Q1", "Num27Q2", "Num28Q1", "Num28Q147", "Num28Q256", "Num29Q1", "Num29Q2", "Num29Q147", "Num29Q148", "Num29Q149", "Num29Q150", "Num29Q151", "Num29Q152", "Num29Q153", "Num29Q154", "Num29Q155", "Num29Q156", "Num29Q239", "Num29Q240", "Num29Q241", "Num29Q242", "Num29Q243", "Num29Q244", "Num29Q245", "Num29Q246", "Num29Q247", "Num29Q248", "Num30Q1", "Num30Q111", "Num30Q184", "Num30Q292", "Num30Q437", "Num30Q546", "Num31Q1", "Num31Q110", "Num32Q1", "Num32Q147", "Num32Q256", "Num32Q363", "Num32Q508", "Num33Q1", "Num33Q2", "Num34Q1", "Num34Q111", "Num34Q184", "Num34Q292", "Num34Q437", "Num34Q546", "Num34Q692", "Num35Q1", "Num35Q147", "Num35Q256", "Num35Q363", "Num35Q508", "Num33Q3"];
          let generator = ["Rand|11|188|1", "Rand|11|188|1", "Rand|0|30|1", "Rand|0|90|1", "Rand|0|100|1", "Rand|1|15|10", "Rand|10|99|1", "Rand|10|99|1", "Rand|2|20|1", "Rand2|1|100|1", "Rand2|1|100|1", "Rand|0|20|4", "Rand|0|20|8", "Rand|0|12|50", "Rand|0|12|100", "Rand|200|9900|1", "Rand|200|9900|1", "Rand|200|9900|1", "Rand|200|9900|1", "Rand|100|990|1", "Rand|100|990|1", "Rand|100|990|1", "Rand2|100|990|1", "Rand2|100|990|1", "Rand|25|970|1", "Rand|25|970|1", "Rand|25|970|1", "Rand|25|870|1", "Rand|200|9870|1", "Rand|2000|98870|1", "Rand|2000|98870|1", "Rand|100|970|1", "Rand|100|970|1", "Rand|100|970|1", "Rand|10000|97000|1", "Rand|-15|-1|1", "Rand|-20|-2|1", "Rand|-30|-3|1", "Rand|-40|-4|1", "Rand|-50|-5|1", "Rand|-60|-6|1", "Rand|-70|-7|1", "Rand|-80|-8|1", "Rand|-90|-9|1", "Rand|-100|-10|1", "Rand2|1000|9900|1", "Rand2|1000|9900|1", "Rand|1000|9900|1", "Rand|1000|9900|1", "Rand|1000|9900|1", "Rand2|100000|990000|1", "Rand2|100000|990000|1", "Rand|-15|-1|1", "Rand|-20|-2|1", "Rand|-30|-3|1", "Rand|-40|-4|1", "Rand|-50|-5|1", "Rand|-60|-6|1", "Rand|-70|-7|1", "Rand|-80|-8|1", "Rand|-90|-9|1", "Rand|-100|-10|1", "Rand|-15|15|1", "Rand|-20|20|1", "Rand|-30|30|1", "Rand|-40|40|1", "Rand|-50|50|1", "Rand|-60|60|1", "Rand|-70|70|1", "Rand|-80|80|1", "Rand|-90|90|1", "Rand|-100|100|1", "Rand|100000|970000|1", "Rand|100000|970000|1", "Rand|100000|970000|1", "Rand|100000|970000|1", "Rand|100000|970000|1", "Rand|100000|970000|1", "Rand|10000|97000|1", "Rand|10000|97000|1", "Rand|100000|970000|1", "Rand|100000|970000|1", "Rand|100000|970000|1", "Rand|100000|970000|1", "Rand|100000|970000|1", "Rand2|1000000|9900000|1", "Rand2|1000000|9900000|1", "Rand|1000000|9900000|1", "Rand|1000000|9900000|1", "Rand|1000000|9900000|1", "Rand|1000000|9900000|1", "Rand|1000000|9900000|1", "Rand|1000000|9900000|1", "Rand|1000000|9900000|1", "Rand|100000|9900000|1", "Rand|100000|9900000|1", "Rand|100000|9900000|1", "Rand|100000|9900000|1", "Rand|100000|9900000|1"];
          var randomNumbers = [];
          var imageString = "";
          var qhtml = ""

          if (q.topic_key == "num48"){//3 digit number from a sum
            let hundreds = GenerateRandom(1,9);
            let tens = GenerateRandom(1,9);
            let ones = GenerateRandom(1,9);
            var correctAnswer = hundreds*100 + tens*10 + ones;
            questionText= hundreds + "x100 + " + tens + "x10 + " + ones + " = ?";
            
            var usedAnswers = [];
            usedAnswers.push(correctAnswer);
            var questionAnswers = [];
            for (let i = 0; i < 3; i++) {
              wrongInt = GenerateUniqueRandom(100,999,usedAnswers);
              usedAnswers.push(wrongInt);
              questionAnswers.push({correct: false, value: wrongInt});
            }
            questionAnswers.push({correct: true, value: correctAnswer});
          }
          else if (q.topic_key == "newnum1"){//count backwards below 10
            let num1 = GenerateRandom(6,10);
            let num2 = GenerateRandom(1,5);
            var correctAnswer = num1-num2;
        
            questionText= "Start at " + num1 + " and count back " + num2;
            
            var usedAnswers = [];
            usedAnswers.push(correctAnswer);
            var questionAnswers = [];
            for (let i = 0; i < 3; i++) {
              wrongInt = GenerateUniqueRandom(1,9,usedAnswers);
              usedAnswers.push(wrongInt);
              questionAnswers.push({correct: false, value: wrongInt});
            }
            questionAnswers.push({correct: true, value: correctAnswer});
          }
          else if (q.topic_key == "newnum2"){//biggest number
            let num1 = GenerateRandom(5,20);
        
            var correctAnswer = num1;
            
            var usedAnswers = [];
            usedAnswers.push(correctAnswer);
            var questionAnswers = [];
            for (let i = 0; i < 3; i++) {
              wrongInt = GenerateUniqueRandom(1,num1-1,usedAnswers);
              usedAnswers.push(wrongInt);
              questionAnswers.push({correct: false, value: wrongInt});
            }
            questionAnswers.push({correct: true, value: correctAnswer});
        
            shuffleArray(usedAnswers);
        
            questionText= "Which is the biggest number? "+ usedAnswers[0] + ", " + usedAnswers[1] + ", " + usedAnswers[2] + ", " + usedAnswers[3];
          }
          else if (q.topic_key == "newnum3"){//smallest number
            let num1 = GenerateRandom(5,15);
        
            var correctAnswer = num1;
            
            var usedAnswers = [];
            usedAnswers.push(correctAnswer);
            var questionAnswers = [];
            for (let i = 0; i < 3; i++) {
              wrongInt = GenerateUniqueRandom(num1,20,usedAnswers);
              usedAnswers.push(wrongInt);
              questionAnswers.push({correct: false, value: wrongInt});
            }
            questionAnswers.push({correct: true, value: correctAnswer});
        
            shuffleArray(usedAnswers);
        
            questionText= "Which is the smallest number? "+ usedAnswers[0] + ", " + usedAnswers[1] + ", " + usedAnswers[2] + ", " + usedAnswers[3];
          }
          else if (q.topic_key == "newnum4"){//number line
            let num1 = GenerateRandom(1,9);
        
            var correctAnswer = num1;
            questionText= "Which number is missing from the number line?";
        
            var usedAnswers = [];
            usedAnswers.push(correctAnswer);
            var questionAnswers = [];
            for (let i = 0; i < 3; i++) {
              wrongInt = GenerateUniqueRandom(1,9,usedAnswers);
              usedAnswers.push(wrongInt);
              questionAnswers.push({correct: false, value: wrongInt});
            }
            questionAnswers.push({correct: true, value: correctAnswer});
        
            shuffleArray(usedAnswers);
        
            qhtml = '<img src="' + GetImage("numberlineblank") + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>';
        
            var rightPos = 86.6;
            var column = 1;
            var topPos = 20;
            var rightModifier = 9.45;
        
            for (let x = 1; x < 10; x++) {
              //swaps columns
        
              if (x == num1){
                qhtml += '<div '+ "style='position:absolute ; color: red; font-weight: bold; font-size: 3.5em; top:" + topPos + "%; right:" + rightPos + "%; ;  zIndex:-1'" + '>?</div>'
              }else{
                qhtml += '<div '+ "style='position:absolute ; font-weight: bold; font-size: 3em; top:" + topPos + "%; right:" + rightPos + "%; ;  zIndex:-1'" + '>'+x+'</div>'
              }
                rightPos -= rightModifier;
            }
        
            
          }
        
          else if (q.topic_key == "newnum6"){ //ten frame 1-10
            let num1 = GenerateRandom(1,10);
        
            var correctAnswer = num1;
            questionText= "What number is represented in the ten frame?";
        
            var usedAnswers = [];
            usedAnswers.push(correctAnswer);
            var questionAnswers = [];
            for (let i = 0; i < 3; i++) {
              wrongInt = GenerateUniqueRandom(1,10,usedAnswers);
              usedAnswers.push(wrongInt);
              questionAnswers.push({correct: false, value: wrongInt});
            }
            questionAnswers.push({correct: true, value: correctAnswer});
        
              qhtml = '<img src="' + GetImage("tenframetable") + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>';
              //then loop through tens
              var rightPos = 70.5;
              var column = 1;
              var topPosTop = -25;
              var topPosBottom = 25;
              var rightModifier = 20;
        
              qhtml+= "<div>";
              for (let x = 0; x < num1; x++) {
                //swaps columns
                let topPos = topPosTop;
                if (column == 2){
                  topPos = topPosBottom;
                  column = 1;
                }else{
                  column = 2;
                }
                qhtml += '<img src="' + GetImage("tenframecounter") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.4,0.4);  zIndex:-1'" + '></img>'
        
                if (column == 1){
                  rightPos -= rightModifier;
                }
              }
              qhtml+="</div>";
          }
          else if (q.topic_key == "newnum5"){ //how many rockets
            let num1 = GenerateRandom(1,10);
        
            var correctAnswer = num1;
            questionText= "How many rockets?";
        
            var usedAnswers = [];
            usedAnswers.push(correctAnswer);
            var questionAnswers = [];
            for (let i = 0; i < 3; i++) {
              wrongInt = GenerateUniqueRandom(1,10,usedAnswers);
              usedAnswers.push(wrongInt);
              questionAnswers.push({correct: false, value: wrongInt});
            }
            questionAnswers.push({correct: true, value: correctAnswer});
        
              //then loop through tens
              var rightPos = 70.5;
              var column = 1;
              var topPosTop = -25;
              var topPosBottom = 25;
              var rightModifier = 20;
        
              qhtml = '<img src="' + GetImage("blank") + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>';
        
              qhtml += "<div>";
              for (let x = 0; x < num1; x++) {
                //swaps columns
                let topPos = topPosTop;
                if (column == 2){
                  topPos = topPosBottom;
                  column = 1;
                }else{
                  column = 2;
                }
                qhtml += '<img src="' + GetImage("rocket") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.4,0.4);  zIndex:-1'" + '></img>'
        
                if (column == 1){
                  rightPos -= rightModifier;
                }
              }
              qhtml+="</div>";
          }
        
          else if (q.topic_key == "num58"){//10-99 missing part whole model
            let num1 = GenerateRandom(10,49);
            let num2 = GenerateRandom(10,49);
            let num3 = num1+num2;
            let correctAnswer = num2;
        
            questionText= "What number is missing from the part-whole model?";
        
            qhtml = "<div>";
            qhtml+= '<img src="' + GetImage("wholemodel") + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(1.0,1.0)'" + '></img>';
            qhtml+= "<b style='font-size:30px ;  position:absolute ; top:10% ; right:47%'>" + num3 + "</b>";
            qhtml+= "<b style='font-size:30px ;  position:absolute ; top:73% ; right:80%'>" + num1 + "</b>"
            qhtml+= "<b style='font-size:30px ;  position:absolute ; top:73% ; right:19%'>" + "?" + "</b>"
            qhtml+= "</div>"
            
            var usedAnswers = [];
            usedAnswers.push(correctAnswer);
            var questionAnswers = [];
            for (let i = 0; i < 3; i++) {
              wrongInt = GenerateUniqueRandom(10,49,usedAnswers);
              usedAnswers.push(wrongInt);
              questionAnswers.push({correct: false, value: wrongInt});
            }
            questionAnswers.push({correct: true, value: correctAnswer});
          }
          else if (q.topic_key == "num57"){//10-99 missing part whole model
            let num1 = GenerateRandom(10,49);
            let num2 = GenerateRandom(10,49);
            var correctAnswer = num1+num2;
            questionText= "What number is missing from the part-whole model?";
        
            qhtml = "<div>";
            qhtml+= '<img src="' + GetImage("wholemodel") + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(1.0,1.0)'" + '></img>';
            qhtml+= "<b style='font-size:30px ;  position:absolute ; top:10% ; right:50%'>" + "?" + "</b>";
            qhtml+= "<b style='font-size:30px ;  position:absolute ; top:73% ; right:80%'>" + num1 + "</b>"
            qhtml+= "<b style='font-size:30px ;  position:absolute ; top:73% ; right:16%'>" + num2 + "</b>"
            qhtml+= "</div>"
            
            var usedAnswers = [];
            usedAnswers.push(correctAnswer);
            var questionAnswers = [];
            for (let i = 0; i < 3; i++) {
              wrongInt = GenerateUniqueRandom(10,99,usedAnswers);
              usedAnswers.push(wrongInt);
              questionAnswers.push({correct: false, value: wrongInt});
            }
            questionAnswers.push({correct: true, value: correctAnswer});
          }
          else if (q.topic_key == "num53"){//100-999 base ten blocks
            let hundreds = GenerateRandom(1,9);
            let tens = GenerateRandom(1,9);
            let ones = GenerateRandom(1,9);
            var correctAnswer = hundreds*100 + tens*10 + ones;
            questionText= "What number is represented by the base ten blocks?";
        
            qhtml = "<div>";
            qhtml+= '<img src="' + GetImage("100cube"+hundreds) + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(1.5,1.5)'" + '></img>';
            qhtml+= '<img src="' + GetImage("10cube"+tens) + '"' + "style='position:relative ; right:-5%% ; zIndex:-1;transform: scale(1.5,1.5)'" + '></img>';
            qhtml+= '<img src="' + GetImage("1cube"+ones) + '"' + "style='position:relative ; right:-10%% ; zIndex:-1;transform: scale(1.5,1.5)'" + '></img>';
            qhtml+= "</div>"
            
            var usedAnswers = [];
            usedAnswers.push(correctAnswer);
            var questionAnswers = [];
            for (let i = 0; i < 3; i++) {
              wrongInt = GenerateUniqueRandom(100,999,usedAnswers);
              usedAnswers.push(wrongInt);
              questionAnswers.push({correct: false, value: wrongInt});
            }
            questionAnswers.push({correct: true, value: correctAnswer});
          }
          else if (q.topic_key == "num49"){//1000-9999 base ten blocks
            let thousands = GenerateRandom(1,6);
            let hundreds = GenerateRandom(1,9);
            let tens = GenerateRandom(1,9);
            let ones = GenerateRandom(1,9);
            var correctAnswer = thousands * 1000 + hundreds*100 + tens*10 + ones;
            questionText= "What number is represented by the base ten blocks?";
        
            qhtml = "<div>";
            qhtml+= '<img src="' + GetImage("1000cube"+thousands) + '"' + "style='position:relative ; right:14% ; zIndex:-1;transform: scale(1.5,1.5)'" + '></img>';
            qhtml+= '<img src="' + GetImage("100cube"+hundreds) + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(1.5,1.5)'" + '></img>';
            qhtml+= '<img src="' + GetImage("10cube"+tens) + '"' + "style='position:relative ; right:-5%% ; zIndex:-1;transform: scale(1.5,1.5)'" + '></img>';
            qhtml+= '<img src="' + GetImage("1cube"+ones) + '"' + "style='position:relative ; right:-10%% ; zIndex:-1;transform: scale(1.5,1.5)'" + '></img>';
            qhtml+= "</div>"
            
            var usedAnswers = [];
            usedAnswers.push(correctAnswer);
            var questionAnswers = [];
            for (let i = 0; i < 3; i++) {
              wrongInt = GenerateUniqueRandom(1000,6999,usedAnswers);
              usedAnswers.push(wrongInt);
              questionAnswers.push({correct: false, value: wrongInt});
            }
            questionAnswers.push({correct: true, value: correctAnswer});
          }
          else if (q.topic_key == "num8"){//numberline
            let line = GenerateRandom(1,19);
            var correctAnswer = line;
            questionText= "What number is shown on the number line?";
            imageString= "numberline"+line;
        
            var usedAnswers = [];
            usedAnswers.push(correctAnswer);
            var questionAnswers = [];
            for (let i = 0; i < 3; i++) {
              wrongInt = GenerateUniqueRandom(1,19,usedAnswers);
              usedAnswers.push(wrongInt);
              questionAnswers.push({correct: false, value: wrongInt});
            }
            questionAnswers.push({correct: true, value: correctAnswer});
            
          }
          else if (q.topic_key == "num61"){ //ten frame
            let num1 = GenerateRandom(1,9);
            let num2 = GenerateRandom(1,9);
        
            var correctAnswer = num1 + num2;
            questionText= "What number is represented in the ten frame?";
        
            var usedAnswers = [];
            usedAnswers.push(correctAnswer);
            var questionAnswers = [];
            for (let i = 0; i < 3; i++) {
              wrongInt = GenerateUniqueRandom(2,20,usedAnswers);
              usedAnswers.push(wrongInt);
              questionAnswers.push({correct: false, value: wrongInt});
            }
            questionAnswers.push({correct: true, value: correctAnswer});
        
              qhtml = '<img src="' + GetImage("tenframetablequestion") + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>';
              //then loop through tens
              var rightPos = 84.5;
              var column = 1;
              var topPosTop = 4;
              var topPosBottom = 28;
              var rightModifier = 7;
        
              qhtml+= "<div>";
              for (let x = 0; x < num1; x++) {
                //swaps columns
                let topPos = topPosTop;
                if (column == 2){
                  topPos = topPosBottom;
                  column = 1;
                }else{
                  column = 2;
                }
                qhtml += '<img src="' + GetImage("tenframecounter") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.3,0.3);  zIndex:-1'" + '></img>'
        
                if (column == 1){
                  rightPos -= rightModifier;
                }
              }
              qhtml+="</div>";
              //loop through ones
              var rightPos = 37.8;
              var column = 1;
              var topPosTop = 4;
              var topPosBottom = 28;
              var rightModifier = 7;
        
              qhtml+= "<div>";
              for (let x = 0; x < num2; x++) {
                //swaps columns
                let topPos = topPosTop;
                if (column == 2){
                  topPos = topPosBottom;
                  column = 1;
                }else{
                  column = 2;
                }
                qhtml += '<img src="' + GetImage("tenframecounter") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.3,0.3);  zIndex:-1'" + '></img>'
        
                if (column == 1){
                  rightPos -= rightModifier;
                }
              }
              qhtml+="</div>";
          }
          else if (q.topic_key == "num60"){ //place value grid 1-99
            let tens = GenerateRandom(1,8);
            let ones = GenerateRandom(1,8);
        
            var correctAnswer = tens*10 + ones;
            questionText= "What number is shown on in the place value grid?";
        
            var usedAnswers = [];
            usedAnswers.push(correctAnswer);
            var questionAnswers = [];
            for (let i = 0; i < 3; i++) {
              wrongInt = GenerateUniqueRandom(10,99,usedAnswers);
              usedAnswers.push(wrongInt);
              questionAnswers.push({correct: false, value: wrongInt});
            }
            questionAnswers.push({correct: true, value: correctAnswer});
        
              qhtml = '<img src="' + GetImage("placetabletensones") + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>';
              //then loop through tens
              var rightPosLeft = 75;
              var rightPosRight = 55;
              var column = 1;
              var topPos = 10;
              var topModifier = 15;
        
              qhtml+= "<div>";
              for (let x = 0; x < tens; x++) {
                //swaps columns
                let rightPos = rightPosLeft;
                if (column == 2){
                  rightPos = rightPosRight;
                  column = 1;
                }else{
                  column = 2;
                }
                qhtml += '<img src="' + GetImage("10token") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'
        
                if (column == 1){
                  topPos += topModifier;
                }
              }
              qhtml+="</div>";
              //loop through ones
              var rightPosLeft = 25;
              var rightPosRight = 5;
              var column = 1;
              var topPos = 10;
              var topModifier = 15;
        
              qhtml+= "<div>";
              for (let x = 0; x < ones; x++) {
                //swaps columns
                let rightPos = rightPosLeft;
                if (column == 2){
                  rightPos = rightPosRight;
                  column = 1;
                }else{
                  column = 2;
                }
                qhtml += '<img src="' + GetImage("1token") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'
        
                if (column == 1){
                  topPos += topModifier;
                }
              }
              qhtml+="</div>";
          }
          else if (q.topic_key == "num55"){ //place value grid 1-99 ODD OR EVEN
            let tens = GenerateRandom(1,9);
            let ones = GenerateRandom(1,9);
        
            var num1 = tens*10 + ones;
            
            var questionText = "Is the number " + num1 + " odd or even?";
           
            var questionAnswers = [];
            if (num1 % 2 == 0){//even
              var correctAnswer = "Even";
              questionAnswers.push({ correct: true, value: "Even" });
            questionAnswers.push({ correct: false, value: "Odd"});
            }else{//odd
              var correctAnswer = "Odd";
              questionAnswers.push({ correct: true, value: "Odd" });
            questionAnswers.push({ correct: false, value: "Even"});
            }
        
              qhtml = '<img src="' + GetImage("placetabletensones") + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>';
              //then loop through tens
              var rightPosLeft = 75;
              var rightPosRight = 55;
              var column = 1;
              var topPos = 10;
              var topModifier = 15;
        
              qhtml+= "<div>";
              for (let x = 0; x < tens; x++) {
                //swaps columns
                let rightPos = rightPosLeft;
                if (column == 2){
                  rightPos = rightPosRight;
                  column = 1;
                }else{
                  column = 2;
                }
                qhtml += '<img src="' + GetImage("10token") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'
        
                if (column == 1){
                  topPos += topModifier;
                }
              }
              qhtml+="</div>";
              //loop through ones
              var rightPosLeft = 25;
              var rightPosRight = 5;
              var column = 1;
              var topPos = 10;
              var topModifier = 15;
        
              qhtml+= "<div>";
              for (let x = 0; x < ones; x++) {
                //swaps columns
                let rightPos = rightPosLeft;
                if (column == 2){
                  rightPos = rightPosRight;
                  column = 1;
                }else{
                  column = 2;
                }
                qhtml += '<img src="' + GetImage("1token") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'
        
                if (column == 1){
                  topPos += topModifier;
                }
              }
              qhtml+="</div>";
          }
        
          else if (q.topic_key == "num40"){ //place value grid 100-999
            let hundreds = GenerateRandom(1,9);
            let tens = GenerateRandom(1,9);
            let ones = GenerateRandom(1,9);
        
            var correctAnswer = hundreds * 100 + tens*10 + ones;
            questionText= "What number is shown on in the place value grid?";
        
            var usedAnswers = [];
            usedAnswers.push(correctAnswer);
            var questionAnswers = [];
            for (let i = 0; i < 3; i++) {
              wrongInt = GenerateUniqueRandom(100,999,usedAnswers);
              usedAnswers.push(wrongInt);
              questionAnswers.push({correct: false, value: wrongInt});
            }
            questionAnswers.push({correct: true, value: correctAnswer});
        
              qhtml = '<img src="' + GetImage("placetablehundredstensones") + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>';
        
              //then loop through hundreds
              var rightPosLeft = 83;
              var rightPosRight = 68;
              var column = 1;
              var topPos = 15;
              var topModifier = 15;
        
              qhtml+= "<div>";
              for (let x = 0; x < hundreds; x++) {
                //swaps columns
                let rightPos = rightPosLeft;
                if (column == 2){
                  rightPos = rightPosRight;
                  column = 1;
                }else{
                  column = 2;
                }
                qhtml += '<img src="' + GetImage("100token") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'
        
                if (column == 1){
                  topPos += topModifier;
                }
              }
              //then loop through tens
              var rightPosLeft = 50;
              var rightPosRight = 35;
              var column = 1;
              var topPos = 15;
              var topModifier = 15;
        
              qhtml+= "<div>";
              for (let x = 0; x < tens; x++) {
                //swaps columns
                let rightPos = rightPosLeft;
                if (column == 2){
                  rightPos = rightPosRight;
                  column = 1;
                }else{
                  column = 2;
                }
                qhtml += '<img src="' + GetImage("10token") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'
        
                if (column == 1){
                  topPos += topModifier;
                }
              }
              qhtml+="</div>";
              //loop through ones
              var rightPosLeft = 17;
              var rightPosRight = 3;
              var column = 1;
              var topPos = 15;
              var topModifier = 15;
        
              qhtml+= "<div>";
              for (let x = 0; x < ones; x++) {
                //swaps columns
                let rightPos = rightPosLeft;
                if (column == 2){
                  rightPos = rightPosRight;
                  column = 1;
                }else{
                  column = 2;
                }
                qhtml += '<img src="' + GetImage("1token") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'
        
                if (column == 1){
                  topPos += topModifier;
                }
              }
              qhtml+="</div>";
              //then loop through ones
          }
          else if (q.topic_key == "num42"){ //place value grid 1000-9999
            let thousands = GenerateRandom(1,8);
            let hundreds = GenerateRandom(1,8);
            let tens = GenerateRandom(1,8);
            let ones = GenerateRandom(1,8);
        
            var correctAnswer = thousands*1000 + hundreds * 100 + tens*10 + ones;
            questionText= "What number is shown on in the place value grid?";
        
            var usedAnswers = [];
            usedAnswers.push(correctAnswer);
            var questionAnswers = [];
            for (let i = 0; i < 3; i++) {
              wrongInt = GenerateUniqueRandom(1000,9999,usedAnswers);
              usedAnswers.push(wrongInt);
              questionAnswers.push({correct: false, value: wrongInt});
            }
            questionAnswers.push({correct: true, value: correctAnswer});
        
              qhtml = '<img src="' + GetImage("placetablethousandshundredsones") + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>';
        
              //then loop through thousands
              var rightPosLeft = 90;
              var rightPosRight = 80;
              var column = 1;
              var topPos = 20;
              var topModifier = 18;
        
              qhtml+= "<div>";
              for (let x = 0; x < thousands; x++) {
                //swaps columns
                let rightPos = rightPosLeft;
                if (column == 2){
                  rightPos = rightPosRight;
                  column = 1;
                }else{
                  column = 2;
                }
                qhtml += '<img src="' + GetImage("1000token") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'
        
                if (column == 1){
                  topPos += topModifier;
                }
              }
              qhtml+="</div>";
        
              //then loop through hundreds
              var rightPosLeft = 65;
              var rightPosRight = 55;
              var column = 1;
              var topPos = 20;
              var topModifier = 18;
        
              qhtml+= "<div>";
              for (let x = 0; x < hundreds; x++) {
                //swaps columns
                let rightPos = rightPosLeft;
                if (column == 2){
                  rightPos = rightPosRight;
                  column = 1;
                }else{
                  column = 2;
                }
                qhtml += '<img src="' + GetImage("100token") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'
        
                if (column == 1){
                  topPos += topModifier;
                }
              }
              qhtml+="</div>";
              //then loop through tens
              var rightPosLeft = 40;
              var rightPosRight = 30;
              var column = 1;
              var topPos = 20;
              var topModifier = 18;
        
              qhtml+= "<div>";
              for (let x = 0; x < tens; x++) {
                //swaps columns
                let rightPos = rightPosLeft;
                if (column == 2){
                  rightPos = rightPosRight;
                  column = 1;
                }else{
                  column = 2;
                }
                qhtml += '<img src="' + GetImage("10token") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'
        
                if (column == 1){
                  topPos += topModifier;
                }
              }
              qhtml+="</div>";
              //loop through ones
              var rightPosLeft = 15;
              var rightPosRight = 5;
              var column = 1;
              var topPos = 20;
              var topModifier = 18;
        
              qhtml+= "<div>";
              for (let x = 0; x < ones; x++) {
                //swaps columns
                let rightPos = rightPosLeft;
                if (column == 2){
                  rightPos = rightPosRight;
                  column = 1;
                }else{
                  column = 2;
                }
                qhtml += '<img src="' + GetImage("1token") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'
        
                if (column == 1){
                  topPos += topModifier;
                }
              }
              qhtml+="</div>";
              //then loop through ones
          }
          else if (q.topic_key == "num56"){//4 digit number from a sum
            let thousands = GenerateRandom(1,9);
            let hundreds = GenerateRandom(1,9);
            let tens = GenerateRandom(1,9);
            let ones = GenerateRandom(1,9);
            var correctAnswer = thousands * 1000 + hundreds*100 + tens*10 + ones;
            questionText= thousands + "x1000 + " + hundreds + "x100 + " + tens + "x10 + " + ones + " = ?";
            
            var usedAnswers = [];
            usedAnswers.push(correctAnswer);
            var questionAnswers = [];
            for (let i = 0; i < 3; i++) {
              wrongInt = GenerateUniqueRandom(1000,9999,usedAnswers);
              usedAnswers.push(wrongInt);
              questionAnswers.push({correct: false, value: wrongInt});
            }
            questionAnswers.push({correct: true, value: correctAnswer});
            
          }
          else if (q.topic_key == "num47"){//6 digit number from a sum
            let hundredthousands = GenerateRandom(1,9);
            let tenthousands = GenerateRandom(1,9);
            let thousands = GenerateRandom(1,9);
            let hundreds = GenerateRandom(1,9);
            let tens = GenerateRandom(1,9);
            let ones = GenerateRandom(1,9);
            var correctAnswer = hundredthousands * 100000 + tenthousands*10000 + thousands * 1000 + hundreds*100 + tens*10 + ones;
            questionText= hundredthousands + "x100,000 + " + tenthousands + "x10,000 + " + thousands + "x1000 + " + hundreds + "x100 + " + tens + "x10 + " + ones + " = ?";
            
            var usedAnswers = [];
            usedAnswers.push(correctAnswer);
            var questionAnswers = [];
            for (let i = 0; i < 3; i++) {
              wrongInt = GenerateUniqueRandom(100000,999999,usedAnswers);
              usedAnswers.push(wrongInt);
              questionAnswers.push({correct: false, value: wrongInt});
            }
            questionAnswers.push({correct: true, value: correctAnswer});
            
          }
          else if (q.topic_key == "num36") {
            var num1 = GenerateRandom(1, 9) * 100;
            var num2 = GenerateRandom(1, 9) * 10;
            var num3 = GenerateRandom(1, 9);
            var questionText = "What is the missing number?";
            questionText += ": " + num1 + "+ _ +" + num3.toString() + " = " + (num1 + num2 + num3);
            correctAnswer = num2;
            var usedAnswers = [];
            var questionAnswers = [];
            usedAnswers.push(correctAnswer);
            for (let i = 0; i < 3; i++) {
              var wrong = GenerateUniqueRandom(10, 90, usedAnswers);
              usedAnswers.push(wrong);
              questionAnswers.push({ correct: false, value: wrong });
            }
            questionAnswers.push({ correct: true, value: correctAnswer });
          } else if (q.topic_key == "num37"){
            var mult10 = [10,100,1000];
            var multby1 = GenerateRandom(0,2);
            var multby2 = GenerateRandom(multby1,2);
            var num1 = GenerateRandom(1,10)*mult10[multby2];
            var num2 = mult10[multby1];
            var correctAnswer = num1/num2;
            var questionText = num1 + " ÷ " + num2 + " =";
            var wrongInt = num1 / mult10[multby2];
        
            var usedAnswers = [];
            var questionAnswers = [];
            for (let i = 0; i < 3; i++) {
              wrongInt = wrongInt*10;
              usedAnswers.push(wrongInt);
              questionAnswers.push({correct: false, value: wrongInt});
            }
            questionAnswers.push({correct: true, value: correctAnswer})
          }else if (q.topic_key == "num38"){
            var mult10 = [10,100,1000];
            var multby1 = GenerateRandom(0,2);
            var n1 = GenerateRandom(1,99);
            var num1 = n1/100;
            var num2 = mult10[GenerateRandom(0,3)];
            var correctAnswer = num1 / num2;
            var wrongone;
        
            var questionText = num1 + " ÷ " + num2 + " =";
        
            var usedAnswers = [];
            var questionAnswers = [];
            num1 = num1 * num2;
            for (let i = 0; i < 3; i++) {
              num1 = num1/10;
              num1 = parseFloat(num1.toFixed(12));
              usedAnswers.push(num1);
              console.log(num1);
              questionAnswers.push({correct: false, value: num1.toString()});
            }
            correctAnswer = parseFloat(correctAnswer.toFixed(12));
            questionAnswers.push({correct: true, value: correctAnswer.toString()})
          }
          else if(q.topic_key == "num9" && q.question_key == "Num9Q3"){
            var num1 = GenerateRandom(1,99);
            var questionText = "What sign is missing: "
            questionText += (q.line_2.replaceAll("$", num1.toLocaleString())).toString();
            var correctAnswer = q.correct_answer;
            var questionAnswers = [];
            questionAnswers.push({ correct: true, value: correctAnswer });
            questionAnswers.push({ correct: false, value: q.wrong_answer_1});
            questionAnswers.push({ correct: false, value: q.wrong_answer_2});
          }else if(q.topic_key == "num17" && q.question_key == "Num17Q3"){
            var num1 = GenerateRandom(100,990);
            var questionText = "What sign is missing: "
            questionText += (q.line_2.replaceAll("$", num1)).toString();
            var correctAnswer = q.correct_answer;
            var questionAnswers = [];
            questionAnswers.push({ correct: true, value: correctAnswer });
            questionAnswers.push({ correct: false, value: q.wrong_answer_1});
            questionAnswers.push({ correct: false, value: q.wrong_answer_2});
          }else if(q.topic_key == "num27" && q.question_key == "Num27Q3"){
            var num1 = GenerateRandom(1000,9990);
            var questionText = "What sign is missing: "
            questionText += (q.line_2.replaceAll("$", num1.toLocaleString())).toString();
            var correctAnswer = q.correct_answer;
            var questionAnswers = [];
            questionAnswers.push({ correct: true, value: correctAnswer });
            questionAnswers.push({ correct: false, value: q.wrong_answer_1});
            questionAnswers.push({ correct: false, value: q.wrong_answer_2});
          }
          else if(q.topic_key == "num33" && q.question_key == "Num33Q3"){
            var num1 = GenerateRandom(10000,99990);
            var questionText = "What sign is missing: "
            questionText += (q.line_2.replaceAll("$", num1.toLocaleString())).toString();
            var correctAnswer = q.correct_answer;
            var questionAnswers = [];
            questionAnswers.push({ correct: true, value: correctAnswer });
            questionAnswers.push({ correct: false, value: q.wrong_answer_1});
            questionAnswers.push({ correct: false, value: q.wrong_answer_2});
          }
          else {
            if (qKeys.includes(q.question_key))
              randomNumbers = parseFormula(q.image, [0, 0]).toString().split('|');
            console.log(randomNumbers);
            if(randomNumbers.length != 0){
              console.log(q);
            }
            var questionText = parseFormula(q.line_1, randomNumbers);
            if (q.line_2 !== "" && q.line_2 !== undefined)
              questionText += ": " + parseFormula(q.line_2, randomNumbers);
            var questionAnswers = [];
            var correctAnswer = parseFormula(q.correct_answer, randomNumbers).toString();
            //console.log(questionText + ": " + correctAnswer);
            let wrongAnswers = [];
            var usedAnswers = [];

            usedAnswers.push(correctAnswer);


            questionAnswers.push({
              correct: true,
              value: correctAnswer
            });
            
            wrongone = uniqueFormula(q.wrong_answer_1, randomNumbers, usedAnswers).toString();
            usedAnswers.push(wrongone);
            questionAnswers.push({ correct: false, value: wrongone });

            
            wrongone = uniqueFormula(q.wrong_answer_2, randomNumbers, usedAnswers).toString();
            usedAnswers.push(wrongone);
            questionAnswers.push({ correct: false, value: wrongone });

            if (q.wrong_answer_3 !== undefined){
              wrongone = uniqueFormula(q.wrong_answer_3, randomNumbers, usedAnswers).toString();
              usedAnswers.push(wrongone);
              questionAnswers.push({ correct: false, value: wrongone });
            }

            if(q.topic_key == "num34" || q.topic_key == "num16"){

            do
            {
            var dupes = false;
              for(let i = 1; i < 4; i++){
                for(let j = 0; j < i; j++){
                  if(questionAnswers[i] != null){

                  console.log(questionAnswers[i].value);
                  if(questionAnswers[i].value == questionAnswers[j].value && i != j){
                    dupes = true;
                    console.log(questionAnswers[i].value);
                    questionAnswers[i].value = GenerateRandom(0,9);
                  }
                }

                }
              }
          }
          while(dupes == true);

          } 
          /*else if(q.topic_key == "num35" || q.topic_key == "num32"){
            do
            {
              var dupes = false;
                for(let i = 1; i < 4; i++){
                  for(let j = 0; j < i; j++){
                    if(questionAnswers[i].value == questionAnswers[j].value && i != j){
                      dupes = true;
                      console.log(questionAnswers[i].value);
                      var valueArray = questionAnswers[i].value.split(',');
                      var newValue = '';
                      for(let k = 0; k < valueArray.length; k++){
                        newValue = newValue + valueArray[k].toString();
                        console.log(newValue);
                      }
                      newValue = parseInt(newValue) + 10;
                      console.log(newValue);
                      questionAnswers[i].value = newValue;
                    }
                  }
                }
            }
            while(dupes == true);
          }*/
        }
         
          shuffleArray(questionAnswers);

          questionText = numberWithCommas(questionText);
          
          questionAnswers.forEach(element => {
            element.value = numberWithCommas(element.value);
          });

          /*
          if (questionText.includes("?") == false && questionText.includes(".") == false){
            questionText = questionText + "?";
          }*/

          let questionObj = {
            question: questionText,
            answers: questionAnswers,
            image: imageString,
            questionHTML: qhtml,
            topic_id: q.topic_key
          };

          newLevelQuestions.push(questionObj);
          //}*/
        });
        shuffleArray(newLevelQuestions);
        levelQs[i] = newLevelQuestions;  
        console.log("tst:" + levelQs[i].value);
      });
      console.log(levelQs);
      setLevels(levelQs);
    }
  }, [questions]);

  return levels !== undefined ? (
    <RatingGame
      questionslist={levels}
      onBack={() => {
        navigate(`/games/${game.id}`);
      }}
      game={game}
      endless={props.endless}
      initialLevel={props.initialLevel}
    />
  ) : (
      <LoadingScreen />
    );
}
